import tracking from '../../../utils/tracking';
import url from '../../../utils/url';

class Segment {
  track(data: any) {
    const { action, attributes, category, label } = data;
    const { value, ...additionalAttributes } = (attributes || {});

    var eventProperties = {
      category,
      label,
      value,
      eventAction: action,
      urlParams: url.getUrlParams() || {},
      ...additionalAttributes
    };
    tracking.trackEvent(action, eventProperties);
  }
}

export { Segment };

export default new Segment();
